<h3 mat-dialog-title class="text-center">{{ title | translate }}</h3>
<mat-dialog-content class="mat-typography text-center">
	<p class="popup-text">{{ message | translate }}</p>
</mat-dialog-content>
